import { useMedia } from '@pp/core/src/hooks/useMedia';

const widthBreakpoints = {
  extraNarrow: 359,
  narrow: 375,
  medium: 620,
  wide: 1024,
  mediumWide: 1366,
  extraWide: 1512,
  extraExtraWide: 1800,
};

/* Larger Than: "mobile-first" */

export const useIsLargerThanExtraWide = (): boolean => {
  //(width >= 1512px)
  return useMedia(`(min-width: ${widthBreakpoints.extraWide}px) and (min-height: 500px)`);
};

export const useIsSmallerThanExtraExtraNarrow = (): boolean => {
  //(width < 360px)
  return useMedia(`(max-width: ${widthBreakpoints.extraNarrow}px)`);
};

export const useIsLargerThanWidth900AndHeight567 = (): boolean => {
  //(width >= 1512px)
  return useMedia('(min-width: 900px) and (min-height: 567px)');
};

export const useIsSmallerThanHeight280AndLandscape = (): boolean => {
  //(height <= 280px)
  return useMedia('(max-height: 280px) and (orientation: landscape)');
};

export const useIsSmallerThanHeight335AndLandscape = (): boolean => {
  //(height <= 335px)
  return useMedia('(max-height: 335px) and (orientation: landscape)');
};
